import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { TenantFeaturesModel } from '../../data/entities';

type TenantFeaturesStatus = 'idle' | 'loading' | 'loaded';

interface TenantFeaturesState {
  features: TenantFeaturesModel | null;
  status: TenantFeaturesStatus;
}

const initialState: TenantFeaturesState = {
  features: null,
  status: 'idle',
};

const tenantFeaturesSlice = createSlice({
  name: 'tenantFeatures',
  initialState,
  reducers: {
    setTenantFeaturesLoading(state) {
      state.status = 'loading';
    },
    setTenantFeatures(state, action: PayloadAction<TenantFeaturesModel | null>) {
      state.features = action.payload;
      state.status = 'loaded';
    },
    resetTenantFeatures(state) {
      state.features = null;
      state.status = 'idle';
    },
  },
});

export const {
  setTenantFeaturesLoading,
  setTenantFeatures,
  resetTenantFeatures,
} = tenantFeaturesSlice.actions;

export default tenantFeaturesSlice.reducer;
